import { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import SEO from '@/components/feature/SEO';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function HomePage() {
  const [activeFaq, setActiveFaq] = useState<number | null>(null);

  const faqs = [
    {
      q: '91影视APP需要付费吗？',
      a: '91影视APP基础功能完全免费，提供海量高清影视内容。部分独家内容和超清画质可能需要VIP会员，但我们提供极具性价比的会员方案，让您畅享所有内容。',
    },
    {
      q: '91影视APP支持哪些设备？',
      a: '91影视APP全面支持Android手机、Android平板、iPhone、iPad以及智能电视和电视盒子。一个账号，多端同步，随时随地畅享观影。',
    },
    {
      q: '下载的视频可以离线观看吗？',
      a: '当然可以！91影视APP支持离线下载功能，您可以将喜欢的电影和剧集下载到手机本地存储，无需网络也能随时观看。多任务并行下载，速度更快。',
    },
    {
      q: '91影视APP的视频清晰度如何？',
      a: '91影视APP支持从流畅到4K超清多档画质选择，采用先进的视频编码技术，在保证画质的同时大幅节省流量。支持HDR10+显示技术，画面更加细腻真实。',
    },
    {
      q: '如何确保下载的是官方正版APP？',
      a: '请务必通过本官方网站下载91影视APP。我们不会通过任何第三方渠道分发安装包。官方网站的下载链接经过严格安全检测，确保您的设备安全。',
    },
    {
      q: '91影视APP会泄露用户隐私吗？',
      a: '我们高度重视用户隐私保护，严格遵守相关法律法规。91影视APP不会收集不必要的个人信息，所有数据传输均经过加密处理。详情请查看我们的隐私政策。',
    },
  ];

  const features = [
    { icon: 'ri-4k-line', title: '4K超清画质', desc: '支持4K HDR播放，影院级视觉享受' },
    { icon: 'ri-download-cloud-2-line', title: '离线下载', desc: '多任务并行下载，随时随地离线观看' },
    { icon: 'ri-smartphone-line', title: '多端同步', desc: '手机/平板/电视无缝切换，进度云端同步' },
    { icon: 'ri-shield-check-line', title: '安全无毒', desc: '官方正版认证，多重安全检测保障' },
    { icon: 'ri-speed-up-line', title: '极速播放', desc: '智能CDN加速，秒开不卡顿' },
    { icon: 'ri-translate-2', title: '多语言字幕', desc: '中英日韩多语字幕，追剧无压力' },
  ];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91精品影视',
    url: 'https://91jingpinys.com',
    description: '91精品影视APP - 提供海量高清影视资源，支持4K播放和离线下载',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'support@91jingpinys.com',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91精品影视',
    url: 'https://91jingpinys.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://91jingpinys.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <Layout>
      <SEO
        title="91精品影视 - 91影视看片APP下载 | 官方正版"
        description="91精品影视APP下载安装，提供91影视看片APP官方版、手机版，最新看片软件下载。支持4K超清播放、离线下载、多端同步，海量影视资源一网打尽。"
        keywords="91精品影视,91影视看片app,91影视看片app下载,91精品影视APP,91影视APP下载安装,91影视看片官方版,手机版,影视APP,看片软件"
        schemaObjects={[orgSchema, webSiteSchema, faqSchema]}
      />

      {/* Hero Section */}
      <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20ambient%20lighting%2C%20deep%20red%20velvet%20curtains%2C%20dark%20luxurious%20interior%2C%20soft%20golden%20spotlights%2C%20elegant%20home%20cinema%20setup%2C%20professional%20cinematography%20aesthetic%2C%20rich%20textures%2C%20dramatic%20lighting%2C%20no%20people&width=1920&height=900&seq=hero-bg-91-01&orientation=landscape"
            alt="91精品影视 - 掌上私人影院"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
        </div>

        <div className="relative z-10 w-full text-center px-4 md:px-8">
          <div className="max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <i className="ri-sparkling-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium">2025全新版本 · 重磅升级</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-heading font-bold text-white leading-tight mb-6">
              91精品影视
              <span className="block text-2xl md:text-3xl font-normal mt-3 text-foreground-200">
                您的掌上私人影院
              </span>
            </h1>
            <p className="text-base md:text-lg text-foreground-300 max-w-xl mx-auto mb-10 leading-relaxed">
              海量高清影视资源 · 4K超清画质 · 离线下载 · 多端同步<br />
              随时随地，畅享极致观影体验
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" id="download">
              <a
                href="#download"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-base whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer hover:scale-105"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
              <a
                href="#download"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/10 text-white border border-white/20 font-medium text-base whitespace-nowrap hover:bg-white/20 transition-all duration-300 cursor-pointer hover:scale-105 backdrop-blur-sm"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
            </div>
            <p className="text-xs text-foreground-500 mt-5">
              官方正版 · 安全无毒 · 已通过安全检测
            </p>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
          <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="w-full bg-background-50 border-b border-background-200/70">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { value: '5000万+', label: '累计用户' },
              { value: '10万+', label: '影视资源' },
              { value: '4.9', label: '用户评分' },
              { value: '99.9%', label: '播放成功率' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="w-full py-16 md:py-24 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              为什么选择91影视？
            </h2>
            <p className="text-sm text-foreground-600 max-w-lg mx-auto">
              六大核心功能，重新定义手机观影体验
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, i) => (
              <div
                key={i}
                className="group p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Categories Preview */}
      <section className="w-full py-16 md:py-24 bg-background-100">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                影视分类
              </h2>
              <p className="text-sm text-foreground-600">八大分类，满足你的所有观影需求</p>
            </div>
            <Link
              to="/category"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              浏览全部分类
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to="/category"
                className="group p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-white transition-colors duration-300">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500">{cat.itemCount}部作品</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Hot Articles */}
      <section className="w-full py-16 md:py-24 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                热门资讯
              </h2>
              <p className="text-sm text-foreground-600">最新影视资讯和使用教程</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.slice(0, 6).map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group block rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 overflow-hidden"
              >
                <div className="aspect-[16/9] bg-background-200 relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-10"></div>
                  <div className="absolute top-3 left-3 z-10">
                    <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                      {article.category}
                    </span>
                  </div>
                  <div className="w-full h-full bg-background-300 flex items-center justify-center">
                    <i className="ri-movie-2-line text-4xl text-foreground-400"></i>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>{article.publishDate}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.viewCount.toLocaleString()}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="w-full py-16 md:py-24 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600">关于91影视APP的常见疑问解答</p>
          </div>
          <div className="flex flex-col gap-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => setActiveFaq(activeFaq === i ? null : i)}
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                  <i
                    className={`text-foreground-500 text-sm transition-transform duration-300 flex-shrink-0 ${
                      activeFaq === i ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    activeFaq === i ? 'max-h-60' : 'max-h-0'
                  }`}
                >
                  <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative w-full py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20accents%2C%20abstract%20film%20strip%20pattern%2C%20luxurious%20theater%20interior%20texture%2C%20deep%20rich%20black%20and%20gold%20color%20scheme%2C%20elegant%20curved%20lines%2C%20premium%20entertainment%20vibe%2C%20no%20text&width=1920&height=700&seq=cta-bg-91-02&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-background-950/85"></div>
        </div>
        <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-8">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
            准备好开启极致观影之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-foreground-300 mb-8 leading-relaxed">
            立即下载91影视APP，畅享海量高清影视内容
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-primary-500 text-white font-semibold text-base whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <i className="ri-download-2-line text-lg"></i>
              免费下载
            </a>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-white/10 text-white border border-white/20 font-medium text-base whitespace-nowrap hover:bg-white/20 transition-all duration-300 cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}